module.exports = __webpack_public_path__ + "static/img/bmch.6a1f169.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/com/bmch.png
// module id = oL6u
// module chunks = 24